/* eslint-disable */
import { PublicClientApplication } from "@azure/msal-browser";
import msalConfig from "../../config/msalConfig";
import { trocarTokenEntraPorJwtSmartForest } from "../requests/TokenExchangeRequests";
import {
    ordemServicoApi, registryApi, singleTreesApi, walterApi,
    walterBIApi, EngineeringApi, SingleTreesOpsApi,
} from "./AxiosClients";

/**
 * Renovação automática da sessão: o jwt SmartForest expira (~23h) e as telas
 * passavam a falhar com 401 até o usuário relogar. O interceptor abaixo captura
 * o primeiro 401 de cada request, renova o jwt em silêncio (MSAL cacheado ->
 * TokenExchange) e repete a chamada original. Se a renovação silenciosa falhar
 * (conta expirada de verdade), derruba a sessão local e volta para o login.
 */

// single-flight: N requests com 401 simultâneos disparam UMA renovação
let renovacaoEmAndamento = null;

const renovarJwt = () => {
    if (!renovacaoEmAndamento) {
        renovacaoEmAndamento = (async () => {
            const msal = new PublicClientApplication(msalConfig);
            await msal.initialize();

            const contas = msal.getAllAccounts();
            if (!contas.length)
                throw new Error("sem conta MSAL em cache para renovar a sessão");

            const resultado = await msal.acquireTokenSilent({
                scopes: ["openid"],
                account: contas[0],
            });

            // grava o jwt novo no localStorage e atualiza os axios clients
            await trocarTokenEntraPorJwtSmartForest(resultado.idToken);
            return localStorage.getItem("jwt");
        })().finally(() => (renovacaoEmAndamento = null));
    }

    return renovacaoEmAndamento;
};

const encerrarSessao = () => {
    localStorage.clear(); // inclui o cache de contas do MSAL
    if (window.location.pathname !== "/") window.location.assign("/");
};

const interceptor = (instancia) => async (error) => {
    const { response, config } = error;

    // só o primeiro 401 de cada request tenta renovar; o TokenExchange fica de
    // fora para a própria renovação não se retroalimentar
    const deveRenovar =
        response?.status === 401 &&
        config &&
        !config._jwtRenovado &&
        !(config.url || "").includes("TokenExchange");

    if (!deveRenovar) return Promise.reject(error);

    config._jwtRenovado = true;

    try {
        const jwt = await renovarJwt();
        config.headers = { ...config.headers, Authorization: `Bearer ${jwt}` };
        return instancia(config);
    } catch (erroRenovacao) {
        console.error(`renovação automática da sessão falhou: ${erroRenovacao}`);
        encerrarSessao();
        return Promise.reject(error);
    }
};

/**
 * Instala o interceptor de renovação em todas as instâncias que usam o jwt
 * (o authApi fica de fora — não autentica com o jwt SmartForest).
 */
const instalarRenovacaoDeSessao = () => {
    [
        ordemServicoApi, registryApi, singleTreesApi, walterApi,
        walterBIApi, EngineeringApi, SingleTreesOpsApi,
    ].forEach((instancia) =>
        instancia.interceptors.response.use((response) => response, interceptor(instancia))
    );
};

export { instalarRenovacaoDeSessao };
